// ADDED
import { useState, useCallback, useEffect } from "react";
import leaveIncentiveBatchService from "../services/leaveIncentiveBatchService";
import hrCalendarService from "../services/hrCalendarService";
import { useGeneralMessage } from "../../common/APICommon";
import { SetAuditTrail } from "../../components/Reports/AuditTrailReportEmployeeSetup";

export const useLeaveIncentiveBatch = (user) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [years, setYears] = useState([]);
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();

  const fetchBatches = useCallback(async () => {
    setLoading(true);
    try {
      const res = await leaveIncentiveBatchService.getAll();
      setData(res.data || []);
    } catch (err) {
      showGeneralMessage("Failed to load batches", false);
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  const fetchYears = useCallback(async () => {
    try {
      const res = await hrCalendarService.getAll();
      setYears(res.data.map(y => ({ value: y.year, label: y.year })));
    } catch (err) { console.error(err); }
  }, []);

  useEffect(() => {
    fetchBatches();
    fetchYears();
  }, [fetchBatches, fetchYears]);

  const handleAction = async (actionFn, id = null, payload = null, auditMsg = "") => {
    setLoading(true);
    try {
      const res = id && payload 
        ? await actionFn(id, payload) 
        : id 
          ? await actionFn(id) 
          : await actionFn(payload);

      if (auditMsg) {
        await SetAuditTrail({
          setupArea: "Leave Incentive Batch",
          actionTaken: auditMsg,
          dateSaved: new Date(),
          savedById: user.id
        });
      }

      showGeneralMessage(res.data?.message || "Success", true);
      await fetchBatches();
      return { success: true, data: res.data };
    } catch (err) {
      showGeneralMessage(err.response?.data?.message || "Action failed", false);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading, data, years, showMessage, message, isSuccess,
    createBatch: (p) => handleAction(leaveIncentiveBatchService.create, null, p, "insert"),
    updateBatch: (id, p) => handleAction(leaveIncentiveBatchService.update, id, p, "update"),
    processBatch: (id) => handleAction(leaveIncentiveBatchService.process, id, null, "process"),
    revertBatch: (id) => handleAction(leaveIncentiveBatchService.revert, id, null, "revert"),
    getBatchDetails: (id) => leaveIncentiveBatchService.getById(id),
    refresh: fetchBatches
  };
};